// AUTO-GENERATED by scripts/font-mirror/build-catalog.ts. Do not edit manually.
// Source: https://withjoy.com/assets/public/fonts/google/{slug}/manifest.json
// To regenerate: `yarn sync-website-fonts --publish` (writes the catalog as the
// final post-publish step).

export const FONT_WEIGHTS_CATALOG: Readonly<Record<string, ReadonlyArray<number>>> = {
  abeezee: [400],
  'abril-fatface': [400],
  alegreya: [400, 700],
  'alegreya-sans-sc': [400, 700],
  aleo: [400, 700],
  'alex-brush': [400],
  'alfa-slab-one': [400],
  allura: [400],
  'almendra-display': [400],
  'amatic-sc': [400, 700],
  amita: [400, 700],
  'antic-didone': [400],
  anton: [400],
  'ar-one-sans': [400, 700],
  'architects-daughter': [400],
  arizonia: [400],
  'averia-serif-libre': [400, 700],
  ballet: [400],
  bangers: [400],
  baskervville: [400, 700],
  'bebas-neue': [400],
  bellota: [400, 700],
  'berkshire-swash': [400],
  'big-shoulders-stencil-display': [400, 700],
  biorhyme: [400, 700],
  bitter: [400, 700],
  'black-and-white-picture': [400],
  boogaloo: [400],
  'bowlby-one': [400],
  bungee: [400],
  'bungee-hairline': [400],
  'bungee-outline': [400],
  'bungee-shade': [400],
  calistoga: [400],
  cambo: [400],
  cantarell: [400, 700],
  capriola: [400],
  caveat: [400, 700],
  'cedarville-cursive': [400],
  charmonman: [400, 700],
  'cherry-swash': [400, 700],
  chivo: [400, 700],
  cinzel: [400, 700],
  'cinzel-decorative': [400, 700],
  'clicker-script': [400],
  coiny: [400],
  comfortaa: [400, 700],
  'coming-soon': [400],
  cormorant: [400, 700],
  'cormorant-garamond': [400, 700],
  'cormorant-infant': [400, 700],
  'courier-prime': [400, 700],
  'crimson-pro': [400, 700],
  'cute-font': [400],
  'dancing-script': [400, 700],
  'dm-serif-display': [400],
  domine: [400, 700],
  dotgothic16: [400],
  dynalight: [400],
  'eb-garamond': [400, 700],
  eczar: [400, 700],
  'elsie-swash-caps': [400],
  'emilys-candy': [400],
  'euphoria-script': [400],
  'fira-sans': [400, 700],
  'fjalla-one': [400],
  forum: [400],
  'fredericka-the-great': [400],
  futura: [700],
  'gilda-display': [400],
  girassol: [400],
  'gravitas-one': [400],
  'great-vibes': [400],
  'grenze-gotisch': [400, 700],
  gudea: [400, 700],
  gugi: [400],
  handlee: [400],
  'happy-monkey': [400],
  'hepta-slab': [400, 700],
  'herr-von-muellerhoff': [400],
  'homemade-apple': [400],
  'ibm-plex-sans': [400, 700],
  'indie-flower': [400],
  'inknut-antiqua': [400, 700],
  'inria-sans': [400, 700],
  'instrument-sans': [400, 700],
  'instrument-serif': [400],
  inter: [400, 700],
  italianno: [400],
  'josefin-sans': [400, 700],
  'josefin-slab': [400, 700],
  jost: [400, 700],
  'julius-sans-one': [400],
  karla: [400, 700],
  karma: [400, 700],
  knewave: [400],
  kranky: [400],
  'lakki-reddy': [400],
  lato: [400, 700],
  'libre-baskerville': [400, 700],
  'libre-bodoni': [400, 700],
  'libre-franklin': [400, 700],
  'life-savers': [400, 700],
  lobster: [400],
  'lobster-two': [400, 700],
  lora: [400, 700],
  lustria: [400],
  'ma-shan-zheng': [400],
  'major-mono-display': [400],
  mali: [400, 700],
  manrope: [400, 700],
  meddon: [400],
  megrim: [400],
  merriweather: [400, 700],
  metamorphous: [400],
  modak: [400],
  molengo: [400],
  monoton: [400],
  'monsieur-la-doulaise': [400],
  montserrat: [400, 700],
  'mrs-saint-delafield': [400],
  mukta: [400, 700],
  muli: [400, 700],
  mulish: [400, 700],
  'new-rocker': [400],
  niconne: [400],
  'nixie-one': [400],
  notable: [400],
  nunito: [400, 700],
  'open-sans': [400, 700],
  oswald: [400, 700],
  oxygen: [400, 700],
  pacifico: [400],
  parisienne: [400],
  'permanent-marker': [400],
  'pinyon-script': [400],
  'pirata-one': [400],
  'playfair-display': [400, 700],
  'poiret-one': [400],
  'poller-one': [400],
  pompiere: [400],
  poppins: [400, 700],
  'proza-libre': [400, 700],
  quattrocento: [400, 700],
  'quattrocento-sans': [400, 700],
  questrial: [400],
  quicksand: [400, 700],
  raleway: [400, 700],
  'raleway-dots': [400],
  'rampart-one': [400],
  'reggae-one': [400],
  roboto: [400, 700],
  'roboto-condensed': [400, 700],
  'roboto-slab': [400, 700],
  'rock-salt': [400],
  rubik: [400, 700],
  ruthie: [400],
  rye: [400],
  sacramento: [400],
  sail: [400],
  sanchez: [400],
  satisfy: [400],
  'scope-one': [400],
  'seaweed-script': [400],
  'sedgwick-ave': [400],
  sen: [400, 700],
  'shadows-into-light': [400],
  'shadows-into-light-two': [400],
  shrikhand: [400],
  'sigmar-one': [400],
  'sirin-stencil': [400],
  'source-sans-pro': [400, 700],
  'space-mono': [400, 700],
  'special-elite': [400],
  spectral: [400, 700],
  spirax: [400],
  srisakdi: [400, 700],
  stalemate: [400],
  'stint-ultra-condensed': [400],
  tangerine: [400, 700],
  taviraj: [400, 700],
  'text-me-one': [400],
  thasadith: [400, 700],
  'train-one': [400],
  truculenta: [400, 700],
  'turret-road': [400, 700],
  ultra: [400],
  unifrakturmaguntia: [400],
  'viaoda-libre': [400],
  volkhov: [400, 700],
  vollkorn: [400, 700],
  'vollkorn-sc': [400, 700],
  vt323: [400],
  windsong: [400],
  'wire-one': [400],
  'work-sans': [400, 700],
  yellowtail: [400],
  'yeseva-one': [400],
  yesteryear: [400],
  zeyada: [400],
};
